import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { IStoreState } from "../../reducers/types";
import { listPaymentMethods } from "../availability/actions/actions";
import { fetchRewardsAccounts } from "../rewards/actions/actions";
import {
  getIsVentureX,
  getRewardsAccounts,
  getRewardsAccountWithLargestEarnForBanner,
} from "../rewards/reducer";
import {
  fetchMegaMenuRegions,
  setStayType,
} from "./actions/actions";
import { fetchTravelWalletDetails } from "../travel-wallet/actions/actions";
import { getTravelWalletOffers } from "../travel-wallet/reducer/selectors";
import { PremierCollectionSearch } from "./component";
import { getStayType } from "./reducer";

const mapStateToProps = (state: IStoreState) => ({
  largestValueAccount: getRewardsAccountWithLargestEarnForBanner(state),
  rewardsAccounts: getRewardsAccounts(state),
  stayType: getStayType(state),
  isVentureX: getIsVentureX(state),
  travelWalletOffers: getTravelWalletOffers(state),
});

const mapDispatchToProps = {
  fetchRewardsAccounts,
  fetchMegaMenuRegions,
  setStayType,
  listPaymentMethods,
  fetchTravelWalletDetails,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PremierCollectionSearchConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPremierCollectionSearch = withRouter(
  connector(PremierCollectionSearch)
);
